<template>
  <div v-if="transaction" class="transaction-details form">
    <div class="form__section">
      <h3 class="page-subtitle">{{ isOwner ? 'Renter' : 'Owner' }} Details</h3>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="user.full_name"
              type="text"
              readonly
              placeholder="Full Name"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="user.phone_number"
              type="text"
              readonly
              placeholder="Phone number"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="tool.address_1"
              type="text"
              readonly
              placeholder="Address Line 1"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="tool.city"
              type="text"
              readonly
              placeholder="City or Suburb"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              :value="tool.postal_code"
              type="number"
              readonly
              placeholder="Postcode"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="tool.state"
              type="text"
              readonly
              placeholder="State"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              :value="tool.country"
              type="text"
              readonly
              placeholder="Country"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div v-if="!isOwner" class="form__section">
      <h3 class="page-subtitle">Payment Method</h3>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              type="text"
              :value="`**** **** **** ${paymentMethod.last4}`"
              required
              readonly
              placeholder="Card Number"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="7">
          <b-form-group>
            <custom-input
              type="text"
              value="**/**"
              required
              readonly
              placeholder="Expiry"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group>
            <custom-input
              type="text"
              value="***"
              required
              readonly
              placeholder="CVC"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="form__section">
      <h3 class="page-subtitle">Billing information</h3>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="billing.address_1"
              type="text"
              readonly
              placeholder="Address Line 1"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="billing.city"
              type="text"
              readonly
              placeholder="City or Suburb"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              :value="billing.postal_code"
              type="number"
              readonly
              placeholder="Postcode"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              :value="billing.state"
              type="text"
              readonly
              placeholder="State"
            ></custom-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              :value="billing.country"
              type="text"
              readonly
              placeholder="Country"
            ></custom-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Transaction details
 * ==================================================================================
 **/

import { mapState } from 'vuex'
import Transaction from '@/models/Transaction'
import CustomInput from '@/components/inputs/CustomInput'

export default {
  components: {
    CustomInput
  },
  props: {
    transaction: {
      type: [Transaction, Object]
    }
  },

  computed: {
    ...mapState({
      self: state => state.auth.user
    }),

    user() {
      return this.transaction.is_tool_owner
        ? this.transaction.renter_details
        : this.transaction.tool.owner
    },

    tool() {
      return this.transaction.tool ? this.transaction.tool : {}
    },

    paymentMethod() {
      return this.transaction && this.transaction.payment_method
        ? this.transaction.payment_method
        : {}
    },

    billing() {
      return this.transaction.billing_details
        ? this.transaction.billing_details
        : {}
    },

    isOwner() {
      return this.transaction ? this.transaction.is_tool_owner : false
    }
  }
}
</script>
